import * as React from 'react';
import Block from "@layout/Block";
import Font from "@layout/Font";
import { PieceFormula } from '@store/index';
import MathJax from 'react-mathjax2';
import './index.scss';

interface Props {
    piece: PieceFormula;
}

const FormulaPiece = ({ piece }: Props) => (
    <Block indent="30">
        {
            piece.title &&
            <Block indent="20">
                <div className="grid">
                    <div className="grid-6 line-bottom">
                        <Font font="primary">
                            { piece.title }
                        </Font>
                    </div>
                </div>
            </Block>
        }

        <MathJax.Context
            input='ascii'
            onError={ (MathJax:any, error:any) => {
                MathJax.Hub.Queue(
                  MathJax.Hub.Typeset()
                );
            } }
            script="https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=AM_HTMLorMML"
            options={ {
                asciimath2jax: {
                     useMathMLspacing: true,
                     delimiters: [["$$","$$"]],
                     preview: "none",
                }
            } }
        >
            <MathJax.Text text={ piece.formula }/>
        </MathJax.Context>
    </Block>
);

export default FormulaPiece;


// WEBPACK FOOTER //
// ./src/components/layout/pieces/Formula/index.tsx